"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

const SearchDialog = dynamic(
	() => import("@/components/search-dialog").then((mod) => mod.SearchDialog),
	{ ssr: false },
);

/** "Search" in the top-right corner; with `shortcut`, ⌘K / Ctrl+K opens it too. */
export function EditorialSearch({ shortcut = false }: { shortcut?: boolean }) {
	const [open, setOpen] = useState(false);

	useEffect(() => {
		if (!shortcut) return;
		function onKey(event: KeyboardEvent) {
			if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
				event.preventDefault();
				setOpen(true);
			}
		}
		window.addEventListener("keydown", onKey);
		return () => window.removeEventListener("keydown", onKey);
	}, [shortcut]);

	return (
		<>
			<button
				type="button"
				className="ed-button-text ed-nav"
				onClick={() => setOpen(true)}
				aria-haspopup="dialog"
				aria-keyshortcuts={shortcut ? "Meta+K Control+K" : undefined}
			>
				Search
			</button>
			{open ? <SearchDialog open={open} onOpenChange={setOpen} /> : null}
		</>
	);
}
